import {Component} from "react";
import {LoadingMessage} from "@/components/SystemMessages";

class SessionTimeout extends Component {
    handleContinueButtonClick = (): void => {
        window.location.href = "/login";
    };

    render(): JSX.Element {
        this.handleContinueButtonClick();
        return <LoadingMessage text="Redirecting to login..." />;
    }
}

export default SessionTimeout;
